import { useCallback } from "react";

export default function PasswordActionsAdmin({
  setPasswordNotice,
  passwordForm,
  setPasswordSaving,
  adminFetch,
  apiBaseUrl,
  readApiJson,
  setPasswordForm,
  texts
}) {
  const submitPasswordChange = useCallback(async (event) => {
    event.preventDefault();
    setPasswordNotice("");

    if (!passwordForm.currentPassword || !passwordForm.newPassword) {
      setPasswordNotice("Please fill in all required password fields.");
      return;
    }

    if (passwordForm.newPassword.length < 6) {
      setPasswordNotice("New password must be at least 6 characters.");
      return;
    }

    if (passwordForm.newPassword !== passwordForm.confirmPassword) {
      setPasswordNotice("Password confirmation does not match.");
      return;
    }

    setPasswordSaving(true);
    try {
      const response = await adminFetch(`${apiBaseUrl}/auth/password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(passwordForm)
      });
      const data = await readApiJson(response);
      if (!response.ok) {
        throw new Error(data.message || "Password update failed");
      }

      setPasswordForm({ currentPassword: "", newPassword: "", confirmPassword: "" });
      setPasswordNotice(texts.passwordUpdated);
    } catch (err) {
      if (err.message !== "Session expired") {
        setPasswordNotice(err.message || "Password update failed");
      }
    } finally {
      setPasswordSaving(false);
    }
  }, [
    adminFetch,
    apiBaseUrl,
    passwordForm,
    readApiJson,
    setPasswordForm,
    setPasswordNotice,
    setPasswordSaving,
    texts.passwordUpdated
  ]);

  return { submitPasswordChange };
}